import React from "react";
import { Box, Typography } from "@mui/material";
import ByzMuiDataGrid from "src/components/core-components/mui/data-grid";
import { useTranslate } from "src/locales";
import { EquivalentStockData } from "./StockAddLayout";

interface EquivalentListProps {
    data: EquivalentStockData[];
    onClose?: () => void;
}

const EquivalentList: React.FC<EquivalentListProps> = ({ data }) => {
    const { t } = useTranslate();

    const columns = [
        { field: "name", headerName: t("menus.stock-grid-name") || "Stok Adı", flex: 1 },
        { field: "current", headerName: t("menus.stock-grid-current") || "Mevcut", width: 120 },
        { field: "unit", headerName: t("menus.stock-grid-unit") || "Birim", width: 100 },
        { field: "barcode", headerName: t("menus.stock-grid-barcode") || "Barkod", width: 150 },
    ];

    return (
        <Box
            sx={{
                width: "100%",
                display: "flex",
                alignItems: "flex-end",
                flexWrap: "wrap",
                alignContent: "flex-end",
                textAlign: "left",
                fontSize: "18px",
                color: "#111827",
                fontFamily: "Poppins, sans-serif",
                mt: 5,
            }}
        >
            <Box
                sx={{
                    minHeight: "245px",
                    width: { xs: "100%", md: "1243px" },
                    position: "relative",
                    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                    borderRadius: "20px",
                    backgroundColor: "#fff",
                    overflow: "hidden",
                    pb: 1,
                }}
            >
                {/* Header (th) */}
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        borderBottom: "1px solid #e0e0e0",
                        boxSizing: "border-box",
                        width: "100%",
                        padding: "10px 20px",
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: "18px",
                            fontWeight: 700,
                            lineHeight: "21.61px",
                            color: "#111827",
                            fontFamily: "Poppins, sans-serif",
                        }}
                    >
                        Muadil Liste
                    </Typography>
                </Box>

                {/* DataGrid Area */}
                <Box sx={{ p: 2, height: 200 }}>
                    <ByzMuiDataGrid
                        rows={data || []}
                        columns={columns}
                        hideFooter
                        density="compact"
                        sx={{
                            border: "none",
                            "& .MuiDataGrid-columnHeaders": {
                                backgroundColor: "#f9fafb",
                            }
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default EquivalentList;
